import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useParams, useLocation } from "react-router-dom";
import {
  getAllSubtopics,
  getAllSubtopicPageContent,
  getSubtopicPageContentById,
  getAllSubtopicInstitutionPageContent,
  getSubtopicInstitutionPageContentById,
  getOneSubtopicCompletedApi,
} from "../helper/apicalls/subtopic";
import RenderPage from "../components/renderPage";
import PageSelection from "../components/pageSelection";
import "../styles/Subject.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-regular-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  getCompletedCourseApi,
  updateCompletedCourseApi,
} from "../helper/apicalls/course";
import SuccessPopup from "../components/common/SuccessPopup";
import CloseIcon from "@mui/icons-material/Close";
import ConversationalAnalysis from "../components/ConversationalAnalysis";
import {
  updateUserCoins,
  updateUserXP,
  checkIsAdmin,
} from "../helper/authUtils";
import { updateUserTimeSpent } from "../helper/apicalls/user";
import edluminaLogo from "../assets/png/edluminaLogo.png";

const SubTopicContent = () => {
  const { coursekey, subjectkey, topickey, subtopickey } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [subtopicsList, setSubtopicsList] = useState([]);

  const activeSubtopicIndex = subtopicsList.findIndex(
    (item) => item.key === subtopickey,
  );
  const nextSubtopic =
    activeSubtopicIndex >= 0 && activeSubtopicIndex < subtopicsList.length - 1
      ? subtopicsList[activeSubtopicIndex + 1]
      : null;
  const prevSubtopic =
    activeSubtopicIndex > 0 ? subtopicsList[activeSubtopicIndex - 1] : null;

  const handleNextSubtopic = () => {
    if (nextSubtopic) {
      navigate(
        `/courses/${coursekey}/${subjectkey}/${topickey}/${nextSubtopic.key}`,
      );
    }
  };

  const handlePrevSubtopic = () => {
    if (prevSubtopic) {
      navigate(
        `/courses/${coursekey}/${subjectkey}/${topickey}/${prevSubtopic.key}`,
      );
    }
  };

  const [activeId, setActiveId] = useState("");
  const [selectRenderPage, setSelectRenderPage] = useState("");
  const [rightItems, setRightItems] = useState([]);
  const [contentData, setContentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectPageComponent, setSelectPageComponent] = useState("");
  const [pageName, setPageName] = useState("");
  const [mcqCurrent, setMcqCurrent] = useState(0);
  const [mcqAnswers, setMcqAnswers] = useState({});
  const [mixedCurrentIndex, setMixedCurrentIndex] = useState(0);
  const [completed, setCompleted] = useState();
  const [successPopup, setSuccessPopup] = useState(false);
  const [showAssistant, setShowAssistant] = useState(false);
  const [isMarkAsComplete, setIsMarkAsComplete] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [renderParentId, setRenderParentId] = useState("");
  const [isPageLocked, setIsPageLocked] = useState(false);
  const [audioUrl, setAudioUrl] = useState();
  const [contentQuizData, setContentQuizData] = useState(null);
  const lastFetchedRef = useRef({ pageId: null, isCompleted: null });

  const refreshCompletionStatus = () => {
    if (subtopickey) {
      getCompletedCourseApi("subtopic", subtopickey)
        .then((res) => {
          if (res) {
            setCompleted(res.data);
          }
        })
        .catch((err) => {
          console.error("Error refreshing completed status:", err);
        });
    }
  };

  const refreshContentQuizData = (pageId) => {
    if (!pageId) return;
    getOneSubtopicCompletedApi(pageId)
      .then((res) => {
        if (res) {
          setContentQuizData(res);
        }
      })
      .catch((err) => {
        console.error("Error fetching single subtopic completed status:", err);
      });
  };

  const findItemById = (itemsList, id) => {
    if (!itemsList || !id) return null;
    for (const item of itemsList) {
      if (String(item?.id) === String(id)) return item;
      if (Array.isArray(item?.child_pages) && item.child_pages.length > 0) {
        const found = findItemById(item.child_pages, id);
        if (found) return found;
      }
    }
    return null;
  };

  const selectPageFromApiResponse = (rightItemsRes) => {
    if (!rightItemsRes || rightItemsRes.length === 0) return null;

    let itemToSelect = null;

    const presentSubtopicKey = Cookies.get("present_subtopic_key");

    if (presentSubtopicKey === subtopickey) {
      const presentPageId = Cookies.get("present_pageid");

      if (presentPageId && presentPageId !== "subtopics") {
        const findItemInResponse = (items, pageId) => {
          for (const item of items) {
            if (String(item.id) === String(pageId)) {
              return item;
            }
            if (item.child_pages && item.child_pages.length > 0) {
              const found = findItemInResponse(item.child_pages, pageId);
              if (found) return found;
            }
          }
          return null;
        };

        itemToSelect = findItemInResponse(rightItemsRes, presentPageId);
      }

      if (!itemToSelect) {
        for (const item of rightItemsRes) {
          if (item.id === "subtopics") continue;
          const savedResult = Cookies.get(`test_result_${item.id}`);
          if (savedResult) {
            try {
              const parsed = JSON.parse(savedResult);
              if (parsed.submitted) {
                itemToSelect = item;
                break;
              }
            } catch (e) {
              console.error("Error parsing test result:", e);
            }
          }
        }
      }
    }

    if (!itemToSelect) {
      const firstItem =
        rightItemsRes[0]?.id === "subtopics" && rightItemsRes.length > 1
          ? rightItemsRes[1]
          : rightItemsRes[0];
      let currentItem = firstItem;
      while (currentItem?.child_pages?.length > 0) {
        currentItem = currentItem.child_pages[0];
      }
      itemToSelect = currentItem;
    }

    return itemToSelect;
  };

  useEffect(() => {
    setIsAdmin(checkIsAdmin());
  }, []);

  useEffect(() => {
    if (checkIsAdmin()) return;
    const courseKey = Cookies.get("current_course_key");
    const subjectKey = Cookies.get("current_subject_key");

    if (!courseKey || !subjectKey) return;

    const intervalId = setInterval(
      () => {
        const payload = {
          course_key: courseKey,
          subject_key: subjectKey,
          time_spent: 120,
        };

        updateUserTimeSpent(payload).catch((error) => {
          console.error(
            "Failed to update time spent (subtopic content):",
            error,
          );
        });
      },
      2 * 60 * 1000,
    );

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    setMcqCurrent(0);
    setMcqAnswers({});
    setMixedCurrentIndex(0);
  }, [selectPageComponent]);

  const markInstitutionContent = (items) => {
    if (!items) return [];
    return items.map((item) => ({
      ...item,
      is_institution: true,
      child_pages: item.child_pages
        ? markInstitutionContent(item.child_pages)
        : undefined,
    }));
  };

  const fetchAllData = async () => {
    try {
      setIsLoading(true);
      if (topickey && subtopickey) {
        const [subtopicsRes, completedRes, rightItemsRes, institutionItemsRes] =
          await Promise.all([
            getAllSubtopics(topickey),
            getCompletedCourseApi("subtopic", subtopickey),
            getAllSubtopicPageContent(subtopickey),
            getAllSubtopicInstitutionPageContent(subtopickey).catch((err) => {
              console.error(
                "Error fetching subtopic institution page content:",
                err,
              );
              return [];
            }),
          ]);

        let currentActiveId = activeId;
        if (subtopicsRes && subtopicsRes.length > 0) {
          setSubtopicsList(subtopicsRes);
          const activeSubtopic = subtopicsRes.find(
            (item) => item.key === subtopickey,
          );

          if (activeSubtopic) {
            setActiveId(activeSubtopic.id);
            setRenderParentId(activeSubtopic.id);
            currentActiveId = activeSubtopic.id;
          } else {
            setActiveId(subtopicsRes[0].id);
            setRenderParentId(subtopicsRes[0].id);
            currentActiveId = subtopicsRes[0].id;
          }
        }

        const completedSnapshot = completedRes?.data;
        if (completedRes) {
          setCompleted(completedSnapshot);
        }

        let mergedRightItems =
          rightItemsRes && Array.isArray(rightItemsRes) ? rightItemsRes : [];
        if (
          institutionItemsRes &&
          Array.isArray(institutionItemsRes) &&
          institutionItemsRes.length > 0
        ) {
          const markedInstItems = markInstitutionContent(institutionItemsRes);
          mergedRightItems = [...mergedRightItems, ...markedInstItems];
        }

        if (mergedRightItems && mergedRightItems.length > 0) {
          const rightItemsList = [
            {
              id: "subtopics",
              name: "Sub Topics",
              page_type: "subtopics",
              sequence: 1,
              title: "Sub Topics",
            },
            ...mergedRightItems,
          ];
          setRightItems(rightItemsList);

          const itemToSelect = selectPageFromApiResponse(rightItemsList);

          if (itemToSelect) {
            setSelectPageComponent(itemToSelect.id);
            setSelectRenderPage(itemToSelect.page_type);

            const parentPage = rightItemsList.find((item) =>
              item.child_pages?.some(
                (child) => String(child.id) === String(itemToSelect.id),
              ),
            );
            let effectiveParent = currentActiveId;
            if (parentPage) {
              effectiveParent = parentPage.id;
            } else if (
              itemToSelect.child_pages &&
              itemToSelect.child_pages.length > 0
            ) {
              effectiveParent = itemToSelect.id;
            }
            setRenderParentId(effectiveParent);

            if (itemToSelect.id && itemToSelect.id !== "subtopics") {
              Cookies.set("present_pageid", itemToSelect.id, { expires: 7 });
              Cookies.set("present_subtopic_key", subtopickey, { expires: 7 });

              if (itemToSelect.page_type !== "test") {
                await fetchContentDetails(
                  itemToSelect.id,
                  itemToSelect.is_institution,
                  false,
                );
              }
            }

            const locked =
              !isAdmin &&
              !itemToSelect.is_institution &&
              !isPageUnlocked(itemToSelect, completedSnapshot);
            setIsPageLocked(locked);
          }
        }
      }
    } catch (error) {
      console.error("Failed to fetch initial data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchContentDetails = async (
    id,
    isInstitution = false,
    showLoader = true,
  ) => {
    setContentQuizData(null);
    try {
      if (showLoader) setIsLoading(true);
      const response = isInstitution
        ? await getSubtopicInstitutionPageContentById(id)
        : await getSubtopicPageContentById(id);
      if (response) {
        setContentData(response.content);
        setPageName(response.name);
        setAudioUrl(response?.tts_s3_url);
      }
    } catch (error) {
      console.error("Failed to fetch content details", error);
    } finally {
      if (showLoader) {
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    }
  };

  const handleCompletedClick = async () => {
    try {
      setIsLoading(true);
      if (subtopickey) {
        const response = await updateCompletedCourseApi("subtopic", {
          subtopic_page_id: selectPageComponent,
          key: subtopickey,
          completed: true,
        });
        if (response) {
          setCompleted((prevCompleted) => {
            const updatedCompleted = { ...prevCompleted };

            const updateArray = (arr) => {
              if (!Array.isArray(arr)) return arr;
              return arr.map((item) => {
                const itemId =
                  typeof item.page === "object"
                    ? item.page?._id || item.page?.id
                    : item.page;

                if (String(itemId) === String(selectPageComponent)) {
                  return { ...item, completed: true };
                }

                if (Array.isArray(item.child_pages)) {
                  return {
                    ...item,
                    child_pages: item.child_pages.map((child) => {
                      const childPageId =
                        typeof child.page === "object"
                          ? child.page?._id || child.page?.id
                          : child.page;
                      if (String(childPageId) === String(selectPageComponent)) {
                        return { ...child, completed: true };
                      }
                      return child;
                    }),
                  };
                }
                return item;
              });
            };

            if (updatedCompleted.data) {
              updatedCompleted.data = updateArray(updatedCompleted.data);
              const exists = updatedCompleted.data.some((item) => {
                const itemId =
                  typeof item.page === "object"
                    ? item.page?._id || item.page?.id
                    : item.page;
                return (
                  String(itemId) === String(selectPageComponent) ||
                  item.child_pages?.some((child) => {
                    const childId =
                      typeof child.page === "object"
                        ? child.page?._id || child.page?.id
                        : child.page;
                    return String(childId) === String(selectPageComponent);
                  })
                );
              });
              if (!exists) {
                updatedCompleted.data.push({
                  page: selectPageComponent,
                  completed: true,
                });
              }
            } else {
              updatedCompleted.data = [
                { page: selectPageComponent, completed: true },
              ];
            }

            if (updatedCompleted.active_recall) {
              updatedCompleted.active_recall = updateArray(
                updatedCompleted.active_recall,
              );
            }

            return updatedCompleted;
          });

          if (response.data?.page_completion_coins) {
            await updateUserCoins();
          }
          if (response.data?.page_completion_xp) {
            updateUserXP(response.data.page_completion_xp);
          }
          setIsMarkAsComplete(true);
          refreshCompletionStatus();
          return response;
        }
      }
    } catch (error) {
      console.error("Failed to fetch subjects", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getFirstContentPage = (item) => {
    let currentItem = item;
    while (currentItem?.child_pages?.length > 0) {
      currentItem = currentItem.child_pages[0];
    }
    return currentItem;
  };

  const isPageUnlocked = (item, completedOverride) => {
    if (isAdmin) return true;
    if (item.is_institution) return true;
    if (
      item.page_type === "active_recall" ||
      item.page_type === "active_recall_test" ||
      item.page_type === "active_recall_content" ||
      item.page_type === "materials" ||
      item.page_type === "material_item" ||
      item.page_type === "subtopics" ||
      item.header
    )
      return true;

    const flattenedStatuses = {};
    const traverse = (arr) => {
      if (!arr || !Array.isArray(arr)) return;
      arr.forEach((it) => {
        const pageId =
          typeof it.page === "object"
            ? it.page?._id || it.page?.id
            : it.page || it.active_recall || it.active_recall_id;
        if (pageId) {
          flattenedStatuses[pageId] = {
            completed: it.completed,
            content_quiz_completed: it.content_quiz_completed,
            teacher_completed: it.teacher_completed,
            is_locked: it.is_locked,
          };
        }
        if (it.child_pages) traverse(it.child_pages);
      });
    };
    const sourceCompleted = completedOverride || completed;
    
    const dataPart = sourceCompleted?.data;
    if (Array.isArray(dataPart)) {
      traverse(dataPart);
    } else if (dataPart && Array.isArray(dataPart.data)) {
      traverse(dataPart.data);
    }
    
    const activeRecallPart = sourceCompleted?.active_recall;
    if (Array.isArray(activeRecallPart)) {
      traverse(activeRecallPart);
    } else if (dataPart && Array.isArray(dataPart.active_recall)) {
      traverse(dataPart.active_recall);
    }

    const itemsToSearch = rightItems || [];
    const flattenedNavItems = [];
    const collectNavItems = (arr) => {
      if (!arr) return;
      arr.forEach((it) => {
        const type = it.page_type?.toLowerCase();
        const isHeader =
          type === "subject" ||
          type === "topics" ||
          type === "subtopics" ||
          type === "courses" ||
          it.header;
        if (!isHeader) {
          flattenedNavItems.push(it);
        }
        if (it.child_pages) collectNavItems(it.child_pages);
      });
    };
    collectNavItems(itemsToSearch);

    // Check own status FIRST — a page that is already completed should never be locked
    const status = flattenedStatuses[item.id];
    if (status && status.is_locked !== undefined) {
      if (status.completed) return true;
      return !status.is_locked && status.teacher_completed !== false;
    }

    // For pages not yet in completed data, apply prev-item gate if prev is a test
    const itemIndex = flattenedNavItems.findIndex(
      (it) => String(it.id) === String(item.id),
    );
    if (itemIndex > 0) {
      const prev = flattenedNavItems[itemIndex - 1];
      if (
        prev &&
        (prev.page_type === "test" || prev.page_type === "active_recall_test")
      ) {
        const prevStatus = flattenedStatuses[prev.id];
        if (
          !prevStatus ||
          !prevStatus.completed ||
          (prev.page_type === "test" && !prevStatus.content_quiz_completed)
        ) {
          return false;
        }
      }
    }

    const firstItem = rightItems?.find((it) => !it.header);
    if (firstItem && item.id === firstItem.id) return true;

    return false;
  };

  useEffect(() => {
    if (!rightItems || rightItems.length === 0 || !selectPageComponent) return;
    const currentItem = findItemById(rightItems, selectPageComponent);
    if (!currentItem) return;
    const locked =
      !isAdmin && !currentItem.is_institution && !isPageUnlocked(currentItem);
    setIsPageLocked(locked);
  }, [completed, rightItems, selectPageComponent, isAdmin]);

  useEffect(() => {
    if (selectRenderPage === "content" && selectPageComponent) {
      const currentItem = findItemById(rightItems, selectPageComponent);
      const isInstitution = currentItem?.is_institution || false;
      if (!isInstitution) {
        const isCurrentlyCompleted = (() => {
          if (!completed) return false;

          const checkList = (list) => {
            if (!Array.isArray(list)) return false;
            for (const item of list) {
              const itemId =
                typeof item.page === "object"
                  ? item.page?._id || item.page?.id
                  : item.page;
              if (
                String(itemId) === String(selectPageComponent) &&
                item.completed
              ) {
                return true;
              }

              if (Array.isArray(item.child_pages)) {
                const childMatch = item.child_pages.find((child) => {
                  const childPageId =
                    typeof child.page === "object"
                      ? child.page?._id || child.page?.id
                      : child.page;
                  return (
                    String(childPageId) === String(selectPageComponent) &&
                    child.completed
                  );
                });
                if (childMatch) {
                  return true;
                }
              }
            }
            return false;
          };

          return (
            checkList(completed?.data) || checkList(completed?.active_recall)
          );
        })();

        // if (isCurrentlyCompleted || isMarkAsComplete) {
        //   const isCompleted = isCurrentlyCompleted || isMarkAsComplete;
        //   if (
        //     lastFetchedRef.current.pageId !== selectPageComponent ||
        //     lastFetchedRef.current.isCompleted !== isCompleted
        //   ) {
        //     lastFetchedRef.current = { pageId: selectPageComponent, isCompleted };
        if (
          !contentQuizData ||
          contentQuizData[0]?.subtopic_page_content !== selectPageComponent
        ) {
          refreshContentQuizData(selectPageComponent);
        }
        // }
      }
    }
  }, [
    selectPageComponent,
    selectRenderPage,
    completed,
    rightItems,
    isMarkAsComplete,
    contentQuizData,
  ]);

  useEffect(() => {
    if (topickey && subtopickey && !successPopup) {
      fetchAllData();
    }
  }, [topickey, subtopickey, successPopup]);

  const isMixedContent = Array.isArray(contentData);

  const questionsForSummary =
    selectRenderPage === "quiz"
      ? contentData
      : selectRenderPage === "truefalse"
        ? contentData
        : selectRenderPage === "fillups"
          ? contentData
          : selectRenderPage === "match"
            ? contentData
            : [];

  const mcqProps =
    (selectRenderPage === "quiz" ||
      selectRenderPage === "truefalse" ||
      isMixedContent) &&
    questionsForSummary
      ? {
          questions: questionsForSummary,
          current: isMixedContent ? mixedCurrentIndex : mcqCurrent,
          answers: isMixedContent ? {} : mcqAnswers,
          onNavigate: isMixedContent ? setMixedCurrentIndex : setMcqCurrent,
          pageType: isMixedContent ? "content" : selectRenderPage,
        }
      : null;

  const [showRightPanel, setShowRightPanel] = useState(false);

  return (
    <div className="subject-layout">
      <div className="subject-layout__left">
        <div
          className="mobile-toggle-btn"
          onClick={() => setShowRightPanel(!showRightPanel)}
        >
          <FontAwesomeIcon icon={faFileLines} />
        </div>
        <div className="subject-scroll-area custom-scrollbar">
          <RenderPage
            activeComponent={selectRenderPage}
            contentData={contentData}
            isLoading={isLoading}
            mcqCurrent={mcqCurrent}
            setMcqCurrent={setMcqCurrent}
            mcqAnswers={mcqAnswers}
            setMcqAnswers={setMcqAnswers}
            mixedCurrentIndex={mixedCurrentIndex}
            setMixedCurrentIndex={setMixedCurrentIndex}
            pageName={pageName}
            activeId={selectPageComponent}
            pageKey={subtopickey}
            pageTitle={"subtopic"}
            completed={completed}
            rightActiveId={selectPageComponent}
            parent={renderParentId}
            handleCompletedClick={handleCompletedClick}
            isMarkAsComplete={isMarkAsComplete}
            setIsMarkAsComplete={setIsMarkAsComplete}
            isPageLocked={isPageLocked}
            audiourl={audioUrl}
            isInstitution={
              findItemById(rightItems, selectPageComponent)?.is_institution ||
              false
            }
            contentQuizData={contentQuizData}
            refreshContentQuizData={refreshContentQuizData}
            onQuizSubmitSuccess={refreshCompletionStatus}
          />
        </div>

        {selectRenderPage === "content" && !isAdmin && (
          <>
            <div
              className="assistant-trigger"
              onClick={() => setShowAssistant(!showAssistant)}
            >
              <img
                src={edluminaLogo}
                height={45}
                className="assistant-image"
                alt="Edlumina logo"
              />
            </div>

            {showAssistant && (
              <div className="assistant-popup">
                <div className="assistant-header">
                  <h3>Ainstein</h3>
                  <button
                    className="close-btn"
                    onClick={() => setShowAssistant(false)}
                  >
                    <CloseIcon fontSize="small" />
                  </button>
                </div>
                <div className="assistant-body">
                  <ConversationalAnalysis
                    question="Welcome to Ainstein what is your doubt?"
                    contentConvo={true}
                    apiQueryParams={{
                      id: selectPageComponent || activeId,
                      key: subtopickey,
                      title: "subtopic",
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {showRightPanel && (
        <div
          className="mobile-backdrop"
          onClick={() => setShowRightPanel(false)}
        />
      )}
      <div
        className={`subject-layout__right ${showRightPanel ? "visible" : ""}`}
      >
        <PageSelection
          subtopic={true}
          title="Content"
          showNavigation={true}
          onNextOverride={handleNextSubtopic}
          onPrevOverride={handlePrevSubtopic}
          disableNextOverride={!nextSubtopic}
          disablePrevOverride={!prevSubtopic}
          items={rightItems}
          activeId={selectPageComponent}
          level="subtopic"
          parentKey={subtopickey}
          onSelect={(data) => {
            setContentData(null);
            const parentPage = rightItems.find((item) =>
              item.child_pages?.some(
                (child) => String(child.id) === String(data.id),
              ),
            );

            const targetItem = getFirstContentPage(data);

            if (targetItem?.child_pages?.length > 0) {
              return;
            }

            setSelectPageComponent(targetItem?.id);
            setSelectRenderPage(targetItem?.page_type);
            const locked =
              !isAdmin &&
              !targetItem.is_institution &&
              !isPageUnlocked(targetItem);
            setIsPageLocked(locked);

            let effectiveParent = activeId;
            if (parentPage) {
              effectiveParent = parentPage.id;
            } else if (data.child_pages && data.child_pages.length > 0) {
              effectiveParent = data.id;
            }
            setRenderParentId(effectiveParent);

            if (targetItem?.id && targetItem?.id !== "subtopics") {
              fetchContentDetails(targetItem.id, targetItem.is_institution);
              Cookies.set("present_pageid", targetItem.id, { expires: 7 });
              Cookies.set("present_subtopic_key", subtopickey, { expires: 7 });
            }

            if (targetItem?.page_type === "content") {
              const searchParams = new URLSearchParams(location.search);
              searchParams.set("contentTab", "normal");
              navigate(`${location.pathname}?${searchParams.toString()}`, {
                replace: true,
              });
            }

            if (window.innerWidth <= 1024) {
              setShowRightPanel(false);
            }
          }}
          mcqProps={mcqProps}
          completed={completed}
          isAdmin={isAdmin}
          isPageLocked={isPageLocked}
        />
      </div>
      <SuccessPopup
        open={successPopup}
        onClose={() => {
          setSuccessPopup(false);
        }}
        message="Marked as Completed Successfully!"
      />
    </div>
  );
};

export default SubTopicContent;
